import { useMemo } from "react";

import { type ICopyResolver } from "types/i18n/ICopyResolver";

import { useActiveLocale } from "./activeLocale";
import { createCopyResolver } from "./resolveCopy";

/**
 * Reads copy constants in the active language; the caller re-renders when the visitor switches language.
 *
 * @returns A resolver bound to the active locale.
 */
export function useCopy(): ICopyResolver {
  const locale = useActiveLocale();
  return useMemo(() => createCopyResolver({ locale: locale }), [locale]);
}
